import { render, staticRenderFns } from "./CohortViewUserPermissionsCard.vue?vue&type=template&id=b4e9ac04&"
import script from "./CohortViewUserPermissionsCard.vue?vue&type=script&lang=js&"
export * from "./CohortViewUserPermissionsCard.vue?vue&type=script&lang=js&"
import style0 from "./CohortViewUserPermissionsCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports